var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useRef, useState, createContext, useEffect, useContext } from '@max/max';
const isMRN = false;
import { getPlatformType, isDianpingAppOrWebview, PlatformType } from '@nibfe/mkt-env-api';
import { getLocationCityId } from './utils/cityUtils';
import View from '@hfe/max-view';
import PopUp from './components/popup/index.web';
import { requestAroundCityInfo } from './requests/api';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import { getActuralDefaultCity } from './requests/GetDefaultCity';
import { useUserInfo } from './requests/use-user';
export const globalContext = createContext({});
const isPlatformDP = isDianpingAppOrWebview() || getPlatformType() === PlatformType.dpMinaWebview;
const MyComponent = (props) => {
    const { demonstrations, citySelect, defaultHomeSelectedCity, isPredictCity, arcImage, originCityStyle, destinationCityStyle } = props;
    const { userInfo } = useUserInfo();
    console.log('defaultHomeSelectedCity', defaultHomeSelectedCity);
    console.log('isPredictCity', isPredictCity);
    const city = {
        title: '',
        value: -1
    };
    const ctx = useContext(global._EngineGlobalContext);
    const originRef = useRef(null);
    const [originCity, setOriginCity] = useState(city);
    const [destinationCityInfo, setDestinationCityInfo] = useState({
        dpCityList: [],
        mtCityList: [],
        nameList: [],
        pinyinList: []
    });
    const [destinationCity, setDestinationCity] = useState({
        title: '上海',
        value: isPlatformDP ? 1 : 10
    });
    useEffect(() => {
        const init = () => __awaiter(void 0, void 0, void 0, function* () {
            if (userInfo.done) {
                try {
                    if (defaultHomeSelectedCity) {
                        yield handleDefaultHomeSelectedCity();
                    }
                    else if (!defaultHomeSelectedCity) {
                        yield handleNonDefaultHomeSelectedCity();
                    }
                }
                catch (error) {
                    console.error('初始化数据失败:', error);
                }
            }
        });
        init();
    }, [userInfo.done]);
    // useEffect(() => {
    //   const handleCitySelection = async () => {
    //     if (defaultHomeSelectedCity) {
    //       await handleDefaultHomeSelectedCity();
    //     } else if (!defaultHomeSelectedCity) {
    //       await handleNonDefaultHomeSelectedCity();
    //     }
    //   };
    //   handleCitySelection();
    // }, []);
    const handleDefaultHomeSelectedCity = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // const res = getSelectedCityInfoSync();
            console.log('finalUserInfo', userInfo);
            const res = yield getActuralDefaultCity({
                ctx,
                isPredictCity,
                userInfo: {
                    userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId,
                    token: userInfo === null || userInfo === void 0 ? void 0 : userInfo.token
                }
            });
            const { cityId } = res;
            const cityMap = citySelect === null || citySelect === void 0 ? void 0 : citySelect.map;
            const ids = isPlatformDP ? cityMap === null || cityMap === void 0 ? void 0 : cityMap.dpCityList : cityMap === null || cityMap === void 0 ? void 0 : cityMap.mtCityList;
            const cityIndex = ids === null || ids === void 0 ? void 0 : ids.indexOf(cityId);
            const isCityIncluded = cityIndex > -1;
            let cityName = '';
            console.log('cityId is include', isCityIncluded, cityId);
            if (isCityIncluded) {
                cityName = cityMap === null || cityMap === void 0 ? void 0 : cityMap.nameList[cityIndex];
                setOriginCity({
                    title: cityName,
                    value: cityId
                });
                originRef.current = {
                    title: cityName,
                    value: cityId
                };
            }
            requestDestinationCityInfo({
                locateCityId: cityId,
                locateCityName: cityName
            });
        }
        catch (error) {
            console.log(error);
        }
    });
    const handleNonDefaultHomeSelectedCity = () => __awaiter(void 0, void 0, void 0, function* () {
        const cityMap = citySelect === null || citySelect === void 0 ? void 0 : citySelect.map;
        const ids = isPlatformDP ? cityMap === null || cityMap === void 0 ? void 0 : cityMap.dpCityList : cityMap === null || cityMap === void 0 ? void 0 : cityMap.mtCityList;
        const nameList = cityMap === null || cityMap === void 0 ? void 0 : cityMap.nameList;
        try {
            const locateCityId = yield getLocationCityId();
            console.log('locateCityId', locateCityId);
            const index = ids === null || ids === void 0 ? void 0 : ids.indexOf(locateCityId);
            let cityName = '';
            if (index !== -1) {
                cityName = nameList[index];
                setOriginCity({
                    title: cityName,
                    value: locateCityId
                });
                originRef.current = {
                    title: cityName,
                    value: locateCityId
                };
            }
            requestDestinationCityInfo({
                locateCityId,
                locateCityName: cityName
            });
        }
        catch (error) {
            console.log(error);
        }
    });
    const requestDestinationCityInfo = ({ locateCityId, locateCityName, queryStartCityId, queryStartCityName }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            const res = yield requestAroundCityInfo({
                params: {
                    locateCityId: locateCityId && locateCityId > 0 ? locateCityId : undefined,
                    locateCityName: locateCityName,
                    queryStartCityId,
                    queryStartCityName,
                    runTimeEnd: Number(props.runTimeEnd) * 60
                }
            });
            const { destinationCitys = [], startCity = {} } = res || {};
            const originCityId = (_a = originRef.current) === null || _a === void 0 ? void 0 : _a.value;
            // 未获取到定位城市，取接口返回的异地预测结构或后端兜底北京
            if (!originCityId || Number(originCityId) < 0) {
                if (startCity === null || startCity === void 0 ? void 0 : startCity.cityId) {
                    setOriginCity({
                        title: startCity === null || startCity === void 0 ? void 0 : startCity.cityName,
                        value: startCity === null || startCity === void 0 ? void 0 : startCity.cityId
                    });
                }
                else {
                    // 兜底北京
                    setOriginCity({
                        title: '北京',
                        value: isPlatformDP ? 2 : 1
                    });
                }
            }
            if (destinationCitys === null || destinationCitys === void 0 ? void 0 : destinationCitys.length) {
                transformDestinationCities(destinationCitys);
            }
            else {
                // 以兜底到达城市，与其他组件通讯
                (_b = props === null || props === void 0 ? void 0 : props._communication) === null || _b === void 0 ? void 0 : _b.emit('cityChanged', destinationCity);
            }
        }
        catch (error) {
            console.log(error);
        }
    });
    const transformDestinationCities = (citys) => {
        var _a, _b, _c, _d, _e;
        const dpCityList = [];
        const mtCityList = [];
        const nameList = [];
        const pinyinList = [];
        // 默认选中第一个第一个城市
        onDestinationChecked({
            title: (_a = citys[0]) === null || _a === void 0 ? void 0 : _a.cityName,
            value: (_b = citys[0]) === null || _b === void 0 ? void 0 : _b.cityId
        }, true);
        (_c = props._LXReport) === null || _c === void 0 ? void 0 : _c.mvReport('b_daodian_lowcode_qqg2ihij_mv', {
            valLab: {
                city_id: ((_d = citys[0]) === null || _d === void 0 ? void 0 : _d.cityId) || '-999',
                city_name: ((_e = citys[0]) === null || _e === void 0 ? void 0 : _e.cityName) || '-999'
            }
        });
        citys.forEach(city => {
            dpCityList.push(city === null || city === void 0 ? void 0 : city.cityId);
            mtCityList.push(city === null || city === void 0 ? void 0 : city.cityId);
            nameList.push(city === null || city === void 0 ? void 0 : city.cityName);
            pinyinList.push(city === null || city === void 0 ? void 0 : city.cityPinyin);
        });
        setDestinationCityInfo({
            dpCityList,
            mtCityList,
            nameList,
            pinyinList
        });
    };
    const onChecked = (city) => {
        var _a;
        if (city.value !== originCity.value) {
            setOriginCity(city);
            originRef.current = city;
            requestDestinationCityInfo({
                queryStartCityId: Number(city.value),
                queryStartCityName: city.title
            });
            (_a = props === null || props === void 0 ? void 0 : props._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport('b_daodian_lowcode_7xlshxub_mc', {
                valLab: {
                    city_id: city.value,
                    city_name: city.title
                }
            });
            console.log('origin citychange', city, originRef.current);
        }
    };
    const onDestinationChecked = (city, ignoreLXReport) => {
        var _a, _b;
        if (city.value !== destinationCity.value) {
            setDestinationCity(city);
            (_a = props === null || props === void 0 ? void 0 : props._communication) === null || _a === void 0 ? void 0 : _a.emit('cityChanged', city);
            !ignoreLXReport && ((_b = props === null || props === void 0 ? void 0 : props._LXReport) === null || _b === void 0 ? void 0 : _b.mcReport('b_daodian_lowcode_qqg2ihij_mc', {
                valLab: {
                    city_id: city.value,
                    city_name: city.title
                }
            }));
            console.log('destination citychange', city);
        }
    };
    return <globalContext.Provider value={{
        _LXReport: props._LXReport
    }}>
      <Sensor once={true} onAppear={() => {
        // 待后续添加埋点
        // props._LXReport?.mvReport('b_daodian_lowcode_s1i934ut_mv');
    }}>
        <View>
          <PopUp x-if={demonstrations === "popup"} cityInfo={citySelect === null || citySelect === void 0 ? void 0 : citySelect.map} destinationCityInfo={destinationCityInfo} originCityStyle={originCityStyle} destinationCityStyle={destinationCityStyle} originCity={originCity} destinationCity={destinationCity} runTimeEnd={props.runTimeEnd} arcImage={arcImage} handleOriginCityChange={onChecked} handleDestinationCityChange={onDestinationChecked} _LXReport={props === null || props === void 0 ? void 0 : props._LXReport} _communication={props === null || props === void 0 ? void 0 : props._communication}/>
        </View>
      </Sensor>
    </globalContext.Provider>;
};
export default memo(MyComponent);
export function _customPVReportParams(params) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const custom = {
            hotel_channel: ((_a = params === null || params === void 0 ? void 0 : params.queryParams) === null || _a === void 0 ? void 0 : _a['hotelchannel']) || '-999',
            tex_id: ((_b = params === null || params === void 0 ? void 0 : params.queryParams) === null || _b === void 0 ? void 0 : _b['pageId']) || '-999'
        };
        if ((_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.href) {
            custom.url = window.location.href;
        }
        return {
            custom
        };
    });
}
